// extracted by mini-css-extract-plugin
export var clauseRow = "_ds-6";
export var emptyState = "_ds-d";
export var filterContent = "_ds-a";
export var filterGroup = "_ds-1";
export var filterGroupContainer = "_ds-0";
export var nestedGroup = "_ds-2";
export var nestedGroupContent = "_ds-b";
export var nestedGroupDepth1 = "_ds-3";
export var nestedGroupDepth2 = "_ds-4";
export var nestedGroupDepth3 = "_ds-5";
export var nestedGroupEmpty = "_ds-c";
export var operatorAnd = "_ds-8";
export var operatorOr = "_ds-9";
export var operatorToggle = "_ds-7";
export var removeGroupButton = "_ds-e";